export const setTitle = (title) => {
	let pageTitle = `OdB`;
	if (title != undefined && title != '') {
		pageTitle = `${pageTitle} - ${title}`
	}

	document.title = pageTitle;
}


// WEBPACK FOOTER //
// ./src/helpers/page-helper.js